import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  
  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setStatus('error');
      return;
    }
    
    const verifyEmail = async () => {
      try {
        const response = await api.get(`/auth/verify/${token}`);
        setEmail(response.data.email);
        setStatus('success');
        
        // Redirect to set password after 2 seconds
        setTimeout(() => {
          navigate(`/auth/set-password?token=${token}`);
        }, 2000);
      } catch (error) {
        setStatus('error');
      }
    };
    
    verifyEmail();
  }, [searchParams, navigate]);
  
  return (
    <div className="text-center animate-slide-up">
      {status === 'verifying' && (
        <>
          <div className="w-16 h-16 mx-auto mb-6 border-4 border-primary-500/30 border-t-primary-500 rounded-full animate-spin" />
          <h2 className="text-2xl font-display font-bold text-white mb-2">
            Verifying your email...
          </h2>
          <p className="text-surface-400">
            Please wait while we verify your email address.
          </p>
        </>
      )}
      
      {status === 'success' && (
        <>
          <div className="w-16 h-16 mx-auto mb-6 bg-green-500/20 rounded-full flex items-center justify-center">
            <CheckCircleIcon className="w-10 h-10 text-green-400" />
          </div>
          <h2 className="text-2xl font-display font-bold text-white mb-2">
            Email verified!
          </h2>
          <p className="text-surface-400">
            Your email <span className="text-white">{email}</span> has been verified.
            <br />Redirecting you to set your password...
          </p>
        </>
      )}
      
      {status === 'error' && (
        <>
          <div className="w-16 h-16 mx-auto mb-6 bg-red-500/20 rounded-full flex items-center justify-center">
            <XCircleIcon className="w-10 h-10 text-red-400" />
          </div>
          <h2 className="text-2xl font-display font-bold text-white mb-2">
            Verification failed
          </h2>
          <p className="text-surface-400 mb-6">
            This verification link is invalid or has expired.
            <br />Please contact your administrator for a new invitation.
          </p>
          <a href="/#/login" className="btn-primary">
            Back to login
          </a>
        </>
      )}
    </div>
  );
}

